import React, { useState } from 'react'
import { connect } from 'react-redux';
import { addToCart as actionAddToCart, minusToCart } from '../redux/actions/cart';
import { getImage, isDigitalMenu, formatPrice } from '../common/Functions';


function Addons({ item, handleClose, actionAddToCart }) {
    const [selectedSize, setSelectedSize] = useState(item.prices[0]['size_id']);
    const [price, setPrice] = useState(parseFloat(item.prices[0]['price']));
    let [addons, setAddons] = useState([]);
    let [qty, setQty] = useState(1);
    const [order_notes, setOrderNotes] = useState("");
    const [error, setError] = useState("");
    const [addonsbyid, setAddonsbyid] =useState([]);

    function handleSizechange(event) {
        const size_id = event.target.value;
        const new_price = item.prices.reduce(((result, price) => result + (price.size_id == size_id ? +price.price_discount : 0)), 0);
        setSelectedSize(size_id);
        setPrice(new_price);
        setAddons([]);
        setAddonsbyid([]);
    }

    function handleAddonChange(event, subItem, subCat) {
        let dummyAddons = [...addons];
        if (event.target.checked) {
            if (typeof addonsbyid[subCat.subcat_id] == 'undefined') {
                addonsbyid[subCat.subcat_id] = [];
            }            
            if (addonsbyid[subCat.subcat_id].length + 1 > subCat.max || addonsbyid[subCat.subcat_id].length + 1 < subCat.min) {               
                setError("You can select minimum " + subCat.min + " and maximum " + subCat.max);
                setTimeout(() => {
                    setError("");
                }, 5000);
                return false;
            }
            subItem.sub_cat_id = subCat.subcat_id;
            dummyAddons.push(subItem)
            addonsbyid[subCat.subcat_id].push(subItem);
            setPrice(prevState => (prevState + +subItem.price));
        }
        else {
            dummyAddons = dummyAddons.filter(addon => addon.sub_item_id != subItem.sub_item_id);
            addonsbyid[subCat.subcat_id] = addonsbyid[subCat.subcat_id].filter(addon => addon.sub_item_id != subItem.sub_item_id);
            setPrice(prevState => (prevState - +subItem.price));
        }
        setAddons(dummyAddons);
        setAddonsbyid(addonsbyid);
        console.log(addons,"addons")
        console.log(addonsbyid,"addonsbyid")
        
    }

    function minusToCart() {
        if (qty == 1) {
            return;
        }
        setQty(--qty);
    }

    function plusToCart() {
        setQty(++qty);
    }

    const getCount = (subCatId) => addons.filter(addon => addon.sub_cat_id == subCatId).length


    const addToCart = () => {
        console.log(selectedSize, "selectedSize");
        const size = item.prices.filter(price => price.size_id == selectedSize);
        console.log(size, "sizesize");
        const addonItems = size ? size[0].add_on_item : [];
        let isSuccess = true;
        if (addonItems) {
            addonItems.forEach(subCat => {
                const itemCount = getCount(subCat.subcat_id);
                if (itemCount > subCat.max || itemCount < subCat.min) {
                    // alert("You can select minimum " + subCat.min + " and maximum " + subCat.max);
                    setError("You can select minimum " + subCat.min + " and maximum " + subCat.max);
                    setTimeout(() => {
                        setError("");
                    }, 5000);
                    isSuccess = false;
                }
            });
        }
        if (isSuccess) {
            actionAddToCart(item, selectedSize, addons, qty, price, order_notes);
            handleClose();
        }

    }



    console.log("rendereed");

    return (
        <div className="customize-content">
            <div className="head">
                <h3>{item.item_name}</h3>
                <button className="close fa fa-times" onClick={handleClose}></button>
            </div>
            <div className="customize-options" key={item.item_id}>
                {error && <div className="alert alert-danger">{error}</div>}
                {item.prices.length > 1 && item.prices.map(price =>
                    <div className="customize-option" key={price.size_id}>
                        <div className="custom-checkbox">
                            <input type="radio" name="size" value={price.size_id} onChange={handleSizechange} checked={price.size_id == selectedSize} />
                            <span className="checkmark"></span>
                        </div>
                        <span>{price.size}</span>
                        {price.price > 0 && <span className="price"> - {formatPrice(price.price)}</span>}
                    </div>)}
                {item.prices.map(price => price.size_id == selectedSize && price.add_on_item.map(addon =>
                    <div className="input-row mt-10" key={addon.sub_cat_id}>
                        <div className="col-1 p-0">
                            <h4>{addon.subcat_name}</h4>
                            {addon.sub_item.map(subItem => <div className="customize-option" key={subItem.sub_item_id}>
                                <div className="custom-checkbox">
                                    <input type="checkbox" name={addon.subcat_id} value={subItem.sub_item_id}
                                        onChange={(e) => handleAddonChange(e, subItem, addon)}                                        
                                        checked={addons.map(addon => addon.sub_item_id).indexOf(subItem.sub_item_id) != -1} disabled={isDigitalMenu} />
                                    <span className="checkmark"></span>
                                </div>
                                <span className="option-name">{subItem.sub_item_name}</span>
                                <span className="price"> - {formatPrice(subItem.price)}</span>
                            </div>)}
                        </div>
                    </div>))}
                    {!isDigitalMenu && <div className="input-row mt-10">
                    <div className="col-1 p-0">
                        <textarea className="form-input" placeholder="Additional Comments" rows="3" value={order_notes} onChange={(e) => setOrderNotes(e.target.value)}></textarea>
                    </div>
                </div>}
                {!isDigitalMenu && <div className="input-row mt-10">
                    <div className="col-2 p-0">
                        {<div className="item-counter w-50">
                            <button className="btn-counter minus" onClick={minusToCart}> <span className="fa fa-minus"></span></button>
                            <button className="btn-counter plus" onClick={plusToCart}><span className="fa fa-plus"></span></button>
                            <input type="text" value={qty} onChange={() => setQty(qty)} />

                        </div>}
                    </div>
                    <div className="col-2 p-0">
                        <input className="btn w-100 bg-dark" type="submit" value={"Add - " + formatPrice(price * qty)} onClick={addToCart} />
                    </div>
                </div>}
            </div>
        </div>
    )
}



export default connect(null, { actionAddToCart })(Addons)
